import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {useStoreContext} from '@store/store-context';
import {cfv} from '@utils/framework';
import {SecondaryNavigation} from '@ui/molecules/nav/navigation';
import {FlatViewIcon, TreeViewIcon} from '@ui/atoms/icons';
import {SyntheticEvent, useState, useMemo} from 'react';

export const QuestionIconWrapper = styled.span<{tooltip?: boolean}>`
  position: relative;

  .tooltip {
    visibility: hidden;
    width: 250px;
    background-color: white;
    font-size: 14px;
    color: #5f5f8c;
    text-align: center;
    padding: 16px;
    border: 1px solid #e4e5fb;
    border-radius: 5px;
    white-space: normal;
    word-wrap: break-word;
    position: absolute;
    white-space: prewrap;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 99999;
    left: -130px;
    margin-top: -110px;
  }
  &:hover .tooltip {
    visibility: ${(props: any) => (props.tooltip === true ? 'visible' : '')};
    opacity: 1;
  }

  .tooltip::before {
    content: ' ';
    position: absolute;
    top: 100%;
    left: 69.5%;
    margin-left: -5px;
    border-width: 11px;
    border-style: solid;
    border-color: #e4e5fb transparent transparent transparent;
  }

  .tooltip::after {
    content: ' ';
    position: absolute;
    top: 100%;
    left: 69.7%;
    margin-left: -5px;
    border-width: 10px;
    border-style: solid;
    border-color: #fafafa transparent transparent transparent;
  }

  @media (max-width: 767px) {
    .tooltip {
      right: 0;
      left: auto;
      max-width: calc(100vw - 40px);
    }
  }
`;

export const GoalViewNavigation = observer(() => {
  const [isTooltipFlat, setIsTooltipFlat] = useState(false);
  const {
    storeDashboardRoutes: {GoalViewTabs, activateGoalViewTab},
    storeYouGoals: {setYouGoalsFilter},
  } = useStoreContext();

  const Navigations = useMemo(() => {
    const nav = [
      {
        active: GoalViewTabs.tree,
        href: '#',
        id: 'alignment',
        onClick: (event: SyntheticEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          setYouGoalsFilter('');

          activateGoalViewTab('tree');
        },
        title: (
          <QuestionIconWrapper
            onMouseEnter={() => setIsTooltipFlat(true)}
            onMouseLeave={() => setIsTooltipFlat(false)}
            tooltip={isTooltipFlat}>
            <TreeViewIcon width={16} height={16} />
            <span className="tooltip">
              View how {cfv().g_oals} ladder up across the company.
            </span>
          </QuestionIconWrapper>
        ),
      },
      {
        active: GoalViewTabs.flat,
        href: '#',
        id: 'flat',
        onClick: (event: SyntheticEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          activateGoalViewTab('flat');
          setYouGoalsFilter('active');
        },
        title: (
          <QuestionIconWrapper
            onMouseEnter={() => setIsTooltipFlat(true)}
            onMouseLeave={() => setIsTooltipFlat(false)}
            tooltip={isTooltipFlat}>
            <FlatViewIcon width={16} height={16} />
            <span className="tooltip">
              You can view your {cfv().g_oals} in flat view.
            </span>
          </QuestionIconWrapper>
        ),
      },
    ];
    return nav;
  }, [
    GoalViewTabs.flat,
    activateGoalViewTab,
    isTooltipFlat,
    GoalViewTabs.tree,

    setYouGoalsFilter,
  ]);

  return (
    <SecondaryNavigation
      // kind="details"
      icons={true}
      navigations={Navigations}
      navStyle={{
        border: 0,
        padding: '4px 12px 0px',
      }}
    />
  );
});
